import React, { useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { label: 'How It Works', href: '#how-it-works' },
    { label: 'Features', href: '#features' },
    { label: 'Pricing', href: '#pricing' },
    { label: 'About', href: '#about' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-[#FDFBF7]/95 backdrop-blur-sm border-b border-stone-100">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a href="/" className="flex items-center gap-2" data-testid="logo-link">
            <span className="font-heading text-2xl md:text-3xl font-semibold text-[#292524]">
              Said<span className="text-[#0D9488]">Simply</span>™
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-testid="desktop-nav">
            {navLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-[#78716C] hover:text-[#0D9488] transition-colors font-medium text-sm"
                data-testid={`nav-link-${link.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-4">
            <Button
              variant="ghost"
              className="text-[#78716C] hover:text-[#0D9488] hover:bg-transparent"
              data-testid="login-btn"
              asChild
            >
              <a href="https://app.trysaidsimply.com/auth">Log In</a>
            </Button>
            <Button
              className="rounded-full bg-[#0D9488] hover:bg-[#0F766E] text-white px-6 shadow-lg shadow-teal-900/10 hover:shadow-teal-900/20 transition-all hover:-translate-y-0.5"
              data-testid="get-started-btn"
              asChild
            >
              <a href="https://app.trysaidsimply.com/auth">Start Free Trial</a>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-[#292524]" />
            ) : (
              <Menu className="w-6 h-6 text-[#292524]" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-[#FDFBF7] border-b border-stone-100"
            data-testid="mobile-menu"
          >
            <div className="container mx-auto px-4 py-4">
              <nav className="flex flex-col gap-4">
                {navLinks.map((link) => (
                  <a
                    key={link.label}
                    href={link.href}
                    className="text-[#78716C] hover:text-[#0D9488] transition-colors font-medium py-2"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {link.label}
                  </a>
                ))}
                <div className="flex flex-col gap-3 pt-4 border-t border-stone-100">
                  <Button
                    variant="ghost"
                    className="text-[#78716C] justify-start"
                    data-testid="mobile-login-btn"
                    asChild
                  >
                    <a href="https://app.trysaidsimply.com/auth">Log In</a>
                  </Button>
                  <Button
                    className="rounded-full bg-[#0D9488] hover:bg-[#0F766E] text-white"
                    data-testid="mobile-start-btn"
                    asChild
                  >
                    <a href="https://app.trysaidsimply.com/auth">Start Free Trial</a>
                  </Button>
                </div>
              </nav>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
};

export default Header;
